import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingList: false,
  loadingCreatePromotion: false,
  loadingDeletePromotion: false,
  reloadListDepositMatches: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_LIST_PROMOTION: (s, data) => (s.loadingList = data),
    LOAD_CREATE_PROMOTION: (s, data) => (s.loadingCreatePromotion = data),
    LOAD_DELETE_PROMOTION: (s, data) => (s.loadingDeletePromotion = data),
    SET_RELOAD_LIST_DEPOSIT_MATCHES: (s, data) =>
      (s.reloadListDepositMatches = data),
  },
  actions: {
    async getPromotionsList({ commit }, params) {
      commit("LOAD_LIST_PROMOTION", true);
      try {
        const res = await this.$api.get("/v1/portal/promotions", {
          params,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_PROMOTION", false);
      }
    },
    async createNewPromotion({ commit }, params) {
      commit("LOAD_CREATE_PROMOTION", true);
      try {
        const res = await this.$api.post("/v1/portal/promotions", params);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_PROMOTION", false);
      }
    },
    async updatePromotion({ commit }, params) {
      commit("LOAD_CREATE_PROMOTION", true);
      try {
        const { promotionId, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/promotions/${promotionId}`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_PROMOTION", false);
      }
    },
    async updatePromotionTargets({ commit }, params) {
      commit("LOAD_CREATE_PROMOTION", true);
      try {
        const { promotionId, ...rest } = params;
        const res = await this.$api.post(
          `/v1/portal/promotions/${promotionId}/targets/`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_PROMOTION", false);
      }
    },
    async deletePromotion({ commit }, promotionId) {
      commit("LOAD_DELETE_PROMOTION", true);
      try {
        const res = await this.$api.delete(
          `/v1/portal/promotions/${promotionId}`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_PROMOTION", false);
      }
    },
    async getDetailPromotion({ commit }, promotionId) {
      commit("LOAD_LIST_PROMOTION", true);
      try {
        const res = await this.$api.get(`/v1/portal/promotions/${promotionId}`);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_PROMOTION", false);
      }
    },
    async deletePromotionTarget({ commit }, params) {
      commit("LOAD_CREATE_PROMOTION", true);
      try {
        const res = await this.$api.delete("/v1/portal/promotions/targets", {
          params,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_PROMOTION", false);
      }
    },
    setReloadListDepositMatches({ commit }, payload) {
      commit("SET_RELOAD_LIST_DEPOSIT_MATCHES", payload);
    },
    async createNewUserGamePlay({ commit }, params) {
      commit("LOAD_CREATE_PROMOTION", true);
      try {
        const res = await this.$api.post("/v1/portal/games/game-plays/create", params);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_PROMOTION", false);
      }
    },
  },
};
